<template>
    <div class="instagram-feed">

        <a
            v-if="overlayLinkText && ! errorMessage"
            class="profile-link"
            :href="overlayLinkUrl"
            target="_blank"
        >
            {{overlayLinkText}}
        </a>

        <div v-if="errorMessage && showErrors" class="container alert alert-danger">
            {{errorMessage}}
        </div>

        <div class="grid">
            <Item
                v-for="item in itemsForDisplay"
                :img="item.img"
                :link="item.link"
            ></Item>
        </div>

    </div>
</template>

<script>
    import Item from "./Components/Item";
    import axios from "axios";

    export default {
        name: "InstagramFeed",
        components: { Item },
        data(){
            return {
                items: [],
                errorMessage: ""
            }
        },
        props: {
            token: String,
            overlayLinkText: String,
            overlayLinkUrl: String,
            restUrl: String,
            showErrors: Boolean,
            max: {
                default: 6,
                type: Number
            }
        },
        mounted(){

            this.requestFreshItems();

        },
        methods: {
            requestFreshItems(){
                return new Promise((resolve, reject)=>{

                    let formData = new FormData();
                    formData.set('token', this.token);
                    formData.set('max', this.max);

                    axios.post(this.restUrl + 'tmcinstfeed/v1/items', formData)
                        .then((response)=>{

                            this.items = response.data?.items || [];

                            //  Show error message if available.
                            if(response.data?.error){
                                this.errorMessage = response.data?.error;
                                console.error(response.data?.error);
                            }

                            resolve();

                        }).catch((reason)=>{
                            reject(reason);
                        });

                });
            }
        },
        computed: {
            itemsForDisplay(){
                return this.items;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .instagram-feed {
        position: relative;
    }

    .profile-link {
        position: absolute;
        background-color: #fff;
        color: #535353;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        padding: 0.2em 1.4em;
        z-index: 3;
        border-radius: 3px;
        text-decoration: none;
        font-size: 1em;
        text-align: center;
    }

    .grid {
        position: relative;
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
</style>